import { FMUnlockDialog, SessionDuration } from "@fokused-me/web-ui";
import { useCallback } from "react";
import { useSession } from "../state/Session";

export const UnlockPage = () => {
   const { session, verifyPassword, startSession } = useSession();

   const handleUnlock = useCallback(
      (password: string, duration: SessionDuration) => {
         startSession(password, duration);
      },
      [startSession]
   );

   const handlePasswordCheck = useCallback(
      (pwd: string) => {
         return verifyPassword(pwd);
      },
      [verifyPassword]
   );

   return (
      <FMUnlockDialog
         duration={(session && session.sessionDuration) || SessionDuration.TODAY}
         onPasswordCheck={handlePasswordCheck}
         onUnlock={handleUnlock}
      />
   );
};
